import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type SyncLocalizedContentMutationVariables = Types.Exact<{
  data: Types.SyncLocalizedContentInput;
}>;


export type SyncLocalizedContentMutation = { syncLocalizedContent: { success?: boolean | null } };


export const SyncLocalizedContentDocument = /*#__PURE__*/ gql`
    mutation syncLocalizedContent($data: SyncLocalizedContentInput!) {
  syncLocalizedContent(data: $data) {
    success
  }
}
    `;

export function useSyncLocalizedContentMutation() {
  return Urql.useMutation<SyncLocalizedContentMutation, SyncLocalizedContentMutationVariables>(SyncLocalizedContentDocument);
};